<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学校管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="学校名称">
          <el-input v-model="formInline.name" @blur="handleQuery" placeholder="请输入基地名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增学校</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载用户导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params"     :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" min-width="160" label="学校名称">
        </custom-table-column>
        <custom-table-column label="使用状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.disabled==0" style="color:var(--blue);">正常</span>
            <span v-else style="color:var(--red);">禁用</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button v-if="scope.row.disabled==0" @click="handleDisabled(scope.row.id,1,'禁用')" type="text" size="small">禁用</el-button>
            <el-button v-if="scope.row.disabled==1" @click="handleDisabled(scope.row.id,0,'解除禁用')" type="text" size="small">解除禁用</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button @click="handleMenuLink(scope.row)" type="text" size="small">菜单关联</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="380px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="学校名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入学校名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',creatSchool)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateSchool)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{delText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteSchool">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 菜单关联 -->
    <el-dialog :close-on-click-modal="false" title="菜单关联" :visible.sync="menuLinkDialogVisible" width="480px">
      <div v-loading="menuLinkLoading" style="max-height: 60vh; overflow: auto; padding: 0 8px;">
        <div style="margin-bottom: 8px;">
          <el-button size="mini" @click="toggleSelectAll">{{ menuLinkAllSelected ? '取消全选' : '全选' }}</el-button>
        </div>
        <el-tree :data="menuLinkTree" ref="menuLinkTree" node-key="index" show-checkbox default-expand-all
          :props="menuLinkProps" @check="handleMenuLinkCheck"></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="menuLinkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMenuLink">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true" show-checkbox :default-checked-keys="checkKeys" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      classRooms: [],
      
      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      formInline: {
        name: '',
      },
      ruleForm: {
        name: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
        // prop: [{ required: true, message: '请输入性质', trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请输入院系', trigger: 'blur' }],
        // person: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        // area: [{ required: true, message: '请输入面积', trigger: 'blur' }],
        // workstation: [{ required: true, message: '请输入工位数', trigger: 'blur' }],

        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
      // ===== 菜单关联 =====
      menuLinkDialogVisible: false,
      menuLinkTree: [],
      menuLinkSchoolId: null,
      menuLinkProps: { children: 'childs', label: 'title' },
      menuLinkAllSelected: false,
      menuLinkCache: null, // api/menu/setting/list 数据缓存（null 表示尚未获取）
      menuLinkLoading: false, // api/menu/setting/list 请求加载状态
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleDisabled(id, state,str) {
      this.confirmBox('warning', `是否${str}该学校`, { school_id: id, disabled: state }, this.updateSchoolStatus);
    },
    async updateSchoolStatus(params) {
      let res = await this.$api.update.updateSchoolStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        // this.dialogVisible = false;
        this.getList();
      }
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteSchool() {
      let params = { school_id: this.delid };
      let res = await this.$api.delet.deleteSchool(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatSchool() {
      // let params = this.$until.deleteNullPrototype(this.ruleForm);
      let params = {
        school_name:this.ruleForm.name,
      }
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatSchool(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateSchool() {
      let params = {
        school_id:this.ruleForm.id,
        school_name:this.ruleForm.name,
      };
      // console.log(params)
      // return
      let res = await this.$api.update.updateSchool(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      if (this.formInline.name) {
        params.name = this.formInline.name;
      }
      let res = await this.$api.query.getSchools(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },

    // ===== 菜单关联 =====
    async handleMenuLink(row) {
      this.menuLinkSchoolId = row.id;
      this.menuLinkAllSelected = false;
      this.menuLinkDialogVisible = true;
      // 菜单数据（api/menu/setting/list）缓存：仅首次获取，后续打开直接复用缓存
      if (this.menuLinkCache === null) {
        this.menuLinkLoading = true;
        try {
          const res = await this.$api.instance.interfaceServer(
            'api/menu/setting/list', 'get', {  },{ isLoadd: false }
          );
          this.menuLinkCache = this.$until.normalizeMenuData(this.$until.extractMenuListData(res && res.data));
        } catch (e) {
          console.error('获取公共菜单失败:', e);
          this.menuLinkCache = [];
        } finally {
          this.menuLinkLoading = false;
        }
      }
      this.menuLinkTree = this.menuLinkCache || [];
      // 查询该学校已关联的菜单并回显勾选（api/menu/linked/list）
      try {
        const res = await this.$api.instance.interfaceServer(
          `api/menu/linked/list?size=999&school_id=${row.id}`, 'get'
        );
        const linkedList = this.extractMenuLinkList(res && res.data);
        const checkedNodes = [];
        this.getMenuLinkChecked(linkedList, checkedNodes);
        this.$nextTick(() => {
          if (this.$refs.menuLinkTree) {
            this.$refs.menuLinkTree.setCheckedKeys(checkedNodes);
          }
        });
      } catch (e) {
        console.error('获取学校菜单关联失败:', e);
        this.$nextTick(() => {
          if (this.$refs.menuLinkTree) {
            this.$refs.menuLinkTree.setCheckedKeys([]);
          }
        });
      }
    },
    // 兼容接口返回的多种结构，提取菜单数组
    extractMenuLinkList(data) {
      if (Array.isArray(data)) return data;
      if (!data || typeof data !== 'object') return [];
      if (Array.isArray(data.data)) return data.data;
      if (Array.isArray(data.list)) return data.list;
      if (Array.isArray(data.records)) return data.records;
      return data.index ? [data] : [];
    },
    // 递归提取已关联菜单的叶子节点 index，用于回显勾选
    getMenuLinkChecked(arr, nodes) {
      if (!Array.isArray(arr)) return;
      arr.forEach((item) => {
        if (item.childs && item.childs.length) {
          this.getMenuLinkChecked(item.childs, nodes);
        } else if (item.index !== undefined && item.index !== null) {
          nodes.push(item.index);
        }
      });
    },
    // 根据勾选结果构造父子结构的菜单数组（参考 roleManage）
    buildMenuLinkArr(arr, bothArr, result) {
      if (!Array.isArray(arr)) return;
      arr.forEach((item) => {
        const hasChilds = item.childs && item.childs.length;
        if (bothArr.indexOf(item.index) > -1) {
          if (hasChilds) {
            const obj = {
              id: item.id,
              index: item.index,
              title: item.title,
              icon: item.icon,
              module: item.module,
              childs: [],
            };
            result.push(obj);
            this.buildMenuLinkArr(item.childs, bothArr, obj.childs);
          } else {
            result.push(item);
          }
        } else if (hasChilds) {
          // 父级未勾选时，继续检查其子级是否有被勾选的
          this.buildMenuLinkArr(item.childs, bothArr, result);
        }
      });
    },
    // 全选 / 取消全选
    toggleSelectAll() {
      const tree = this.$refs.menuLinkTree;
      if (!tree) return;
      const allLeafKeys = [];
      this.getMenuLinkChecked(this.menuLinkTree, allLeafKeys);
      const checkedLeafKeys = tree.getCheckedKeys(true);
      const isAllChecked = allLeafKeys.length > 0 && checkedLeafKeys.length >= allLeafKeys.length;
      tree.setCheckedKeys(isAllChecked ? [] : allLeafKeys);
      this.menuLinkAllSelected = !isAllChecked;
    },
    // 勾选变化时同步"全选"按钮状态
    handleMenuLinkCheck() {
      const tree = this.$refs.menuLinkTree;
      if (!tree) return;
      const allLeafKeys = [];
      this.getMenuLinkChecked(this.menuLinkTree, allLeafKeys);
      this.menuLinkAllSelected = allLeafKeys.length > 0 && tree.getCheckedKeys(true).length >= allLeafKeys.length;
    },
    async saveMenuLink() {
      const tree = this.$refs.menuLinkTree;
      if (!tree) return;
      const bothArr = tree.getCheckedKeys().concat(tree.getHalfCheckedKeys());
      const setArr = [];
      this.buildMenuLinkArr(this.menuLinkTree, bothArr, setArr);
      if (!setArr.length) {
        this.$message.warning('请先勾选需要关联的菜单');
        return;
      }
      const params = {
        menu: JSON.stringify(setArr),
        school_id: this.menuLinkSchoolId,
      };
      try {
        const res = await this.$api.instance.interfaceServer('api/menu/linked/create', 'post', params);
        if (res.code == 0) {
          this.$message.success('菜单关联保存成功！');
          this.menuLinkDialogVisible = false;
        }
      } catch (e) {
        console.error('保存菜单关联失败:', e);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: 90px;
}
</style>
